import React from 'react';
import PropTypes from 'prop-types';

import MartyLink from 'components/common/MartyLink';

const PrimaryAddress = ({ address }, { testId }) => {
  if (address) {
    const { name, mailingAddress, phone } = address;
    const { fullName } = name;
    const { addressLine1, addressLine2, city, stateOrRegion, postalCode, countryName } = mailingAddress;
    const { voice: { primary: { number } } } = phone;

    return (
      <div data-test-id={testId('primaryShippingAddress')}>
        <h3>Primary Shipping Address</h3>
        <div data-test-id={testId('priAddressName')}>{fullName}</div>
        <div data-test-id={testId('priAddressLine1')}>{addressLine1}</div>
        <div data-test-id={testId('priAddressLine2')}>{addressLine2}</div>
        <div data-test-id={testId('priAddressCityStateZip')}>{city}, {stateOrRegion} {postalCode}</div>
        <div data-test-id={testId('priAddressCountry')}>{countryName}</div>
        <div data-test-id={testId('priAddressPhoneNumber')}>{number}</div>
        <MartyLink to="/addresses" data-test-id={testId('manageAddresses')}>Manage My Addresses</MartyLink>
      </div>
    );
  } else {
    return (
      <div data-test-id={testId('primaryShippingAddressEmpty')}>
        <h3>Primary Shipping Address</h3>
        <div>No address available</div>
        <MartyLink to="/addresses/new" data-test-id={testId('addNewShippingAddressPlus')}>Add a new shipping address</MartyLink>
      </div>
    );
  }
};

PrimaryAddress.contextTypes = {
  testId: PropTypes.func
};

PrimaryAddress.propTypes = {
  address: PropTypes.object,
  testId: PropTypes.func
};

export default PrimaryAddress;
